import type { FC, ReactNode } from "react";
import { mergeClasses } from "@huub-web/utils";

import { Text, type TextProps } from "../Text/Text";
import { addOnStyle } from "./InputAddOn.css";
import type { IconProp } from "../../props";
import { Icon, type IconProps } from "../Icon/Icon";

export type InputAddOnProps = Pick<TextProps, "color"> &
  IconProp & {
    variant: "leading" | "trailing";
    children?: ReactNode;
    iconSize?: IconProps["size"];
  };

export const InputAddOn: FC<InputAddOnProps> = ({
  variant = "leading",
  color = "placeholder",
  iconSize = "s",
  icon,
  children,
}) => (
  <Text
    color={color}
    className={mergeClasses(addOnStyle({ variant }), "add-on")}
  >
    {icon && <Icon icon={icon} size={iconSize} />}
    {children}
  </Text>
);
